import React, { useState, useEffect } from 'react'
import data from '@/data/newsletters.json'
import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Clean from '@/components/Hero/Clean'
import newsletterdata from '@/data/newsletters'
import Steps from '@/components/Steps/Minimal'
import { subscribeSection } from '@/components/useFunctions'

const IndexPage = ({ pageContext }) => {
  const newsletter = data.find(item => item.slug === pageContext.slug)
  const {
    name,
    description,
    field,
    frequency,
    img,
    logo,
    slug,
    subscription,
    shortDescription,
    accentColor,
    btnColor,
    foregroundColor,
    bgColor,
    labelText,
  } = newsletter

  const NewsMinimal = ({ email }) => {
    const [localnewsletters, setLocalnewsletters] = useState([])

    useEffect(() => {
      setLocalnewsletters([...data])
      subscribeSection(email, newsletter.field).then(res => {
        console.log('registered!')
        typeof window !== 'undefined' &&
          typeof window.gtag !== 'undefined' &&
          window.gtag('event', 'sign_up', {
            email: email,
            signup: 'newsletter',
            newsletter: newsletter.field,
          })
      })
    }, [])

    return <div></div>
  }

  const SecondStep = ({ email }) => {
    return (
      <span className="block text-xl leading-tight">
        ¡Todo listo! Este newsletter te llegará a{' '}
        <i className="not-italic underline">{email}</i>.
      </span>
    )
  }

  const definitiveDescription =
    shortDescription && shortDescription.length > 0
      ? shortDescription
      : description

  return (
    <Layout withHeader={false}>
      <SEO />
      <Clean
        newsletters={newsletterdata}
        accentColor={accentColor}
        btnColor={btnColor}
        bgColor={bgColor}
        foregroundColor={foregroundColor}
        steps={
          <Steps
            newsletters={data}
            SecondStep={SecondStep}
            Reveal={NewsMinimal}
            btnColor={btnColor}
            accentColor={accentColor}
            bgColor={bgColor}
            foregroundColor={foregroundColor}
            labelText={labelText}
          />
        }
      />
    </Layout>
  )
}

export default IndexPage
